module.exports = __webpack_public_path__ + "static/img/img46.6690176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img46.png
// module id = ROgY
// module chunks = 1